export default "__VITE_ASSET__i_M5DYrZ__"